// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import "./styles/common.scss";
Vue.config.productionTip = false;

// liss modify 2023-11-17 删除登录操作
// import { getToken } from "@/utils/auth.js"
// import { tansParams } from '@/utils/commonUtils.js';
// // 路由判断登录 根据路由配置文件的参数
// router.beforeEach((to, from, next) => {
//     if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
//         const isLogin = !(getToken() == "" || getToken() == undefined);
//         if (isLogin) {
//             next();
//         } else {
//             console.log("未登录")
//             const query = to.query;
//             if ((JSON.stringify(query) != "{}")) {
//                 next(`/login?redirect=${to.path}?${tansParams(query)}`)
//             } else {
//                 next(`/login?redirect=${to.path}`)
//             }
//         }
//     } else {
//         next();
//     }
// });
// end
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js